export default __webpack_public_path__ + "static/media/person-large.2298a7f2.svg";